import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Hero2 from "../components/Hero2/Hero2";
import Gavani from "../assets/kaangavani.jpg";
import SoftwareSolutionsSection5 from "../components/SoftwareSolutions/SoftwareSolutionsSection5/SoftwareSolutionsSection5";
import AdvertisingAndMediaImg from "../assets/advandmediahero.jpg";
import AMSection1 from "../components/AdvertisingAndMedia/AdvertisingAndMediaSection1/AdvertisingAndMediaSection1";
import AMSection2 from "../components/AdvertisingAndMedia/AdvertisingAndMediaSection2/AdvertisingAndMediaSection2";
import OurServicesSection3 from "../components/OurServices/OurServices3/ourservices3";
import CreativeDesignSection4 from "../components/CreativeDesign/CreativeDesignSection4/CreativeDesignSection4";
import SEO from "../components/SEO";
import { useTranslation } from "react-i18next";

const AdvertisingAndMedia = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="AdvertisingAndMedia" />
      <Navbar />
      <Hero2
        cName="contact-us-hero2"
        heroImg={AdvertisingAndMediaImg}
        title={t("pages.advertisingMedia.title")}
        text={t("pages.advertisingMedia.text")}
      />
      <AMSection1 />
      <AMSection2 />
      <SoftwareSolutionsSection5
        quote={t("pages.advertisingMedia.quote")}
        author={t("pages.advertisingMedia.author")}
        title={t("pages.advertisingMedia.title-people")}
        profileImage={Gavani}
      />
      <OurServicesSection3 />
      <CreativeDesignSection4 />
      <Footer />
    </>
  );
};

export default AdvertisingAndMedia;
